import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { DishServices } from "../../../services";
import { ConfigurationServices } from '../../../../configuration/services';
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the PartialPageTitlePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-dish-partial-indicators',
    templateUrl: 'dish-partial-indicators.html',
})
export class DishPartialIndicatorsPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public dishServices: DishServices,
        public configurationServices: ConfigurationServices,
        public translate: TranslateService,) {
    }

    checkState(allergen_uid) {
        var index = this.dishServices.dish_allergens_tmp.indexOf(allergen_uid, 0);
        if (index > -1) {
            return true
        } else {
            return false
        }
    }

    insert(allergen_uid) {
        if (this.globals.checkLimitsByLicense('dishes', 'indicators')) {
            this.dishServices.dish_allergens_tmp.push(allergen_uid);
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    delete(allergen_uid) {
        if (this.globals.checkLimitsByLicense('dishes', 'indicators')) {
            var index = this.dishServices.dish_allergens_tmp.indexOf(allergen_uid, 0);
            if (index > -1) {
                this.dishServices.dish_allergens_tmp.splice(index, 1);
            }
        }
        else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-create/dish-create-allergens/dish-partial-indicators/dish-partial-indicators.ts